export enum GroupPrivacy {
  Public = 'Public',
  OpenPrivate = 'OpenPrivate',
  Private = 'Private',
  InviteOnly = 'InviteOnly'
}
